<template>
  <Modal
    :name="name"
    :clickToClose="clickToClose"
    :adaptive="adaptive"
    :x="x"
    :y="y"
    :width="width"
    :height="height"
    :drag-handle="'.drag-handle'"
    :draggable="draggable"
    :resizable="resizable"
    :active="active"
    :class="{ active: active === true, popupClass }"
    class="single-popup"
    @before-close="beforeClose"
  >
    <div class="popup-container">
      <div class="popup-header drag-handle noselect" :class="{ active: draggable === true }">
        <div class="title">{{ title }}</div>
        <div class="buttons">
          <div class="close">
            <button @click="close">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="content">
        <slot></slot>
      </div>
    </div>
  </Modal>
</template>
<style lang="less" scoped src="@/assets/less/components/popup-styles.less"></style>

<script>
export default {
  props: {
    name: String,
    toggled: Boolean,
    active: Boolean,
    adaptive: Boolean,
    draggable: Boolean,
    clickToClose: Boolean,
    parent: Boolean,
    resizable: Boolean,
    title: String,
    popupClass: String,
    width: [Number, String],
    height: [Number, String],
    x: [Number, String],
    y: [Number, String]
  },
  methods: {
    close(hide) {
      this.$emit('close')
      this.$modal.hide(this.name)
    },
    beforeClose() {
      this.$emit('close')
    }
  }
}
</script>
